export default class EventTracker {
  static trackEvent(tracking, category, action, additionalData) {
    /**
     * tracking: props.tracking from the component
     * category: string
     * action: string
     * additionalData: object
     */
    tracking.event(category, action, {
      ...additionalData,
      created_at: new Date().toLocaleDateString("en-US")
    });
  }
}